import React from 'react';
import {
  FormControlLabel, Checkbox, TextField,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const GroundTruthEnableQuestion = ({
  onChange,
  currentMinimumScore,
  currentMaximumScore,
  hideMinimumScore,
  disabled,
  disableMaximumScore,
  sectionId,
  questionId,
}) => {
  const considerInGroundTruth = currentMinimumScore !== undefined && currentMinimumScore !== null;

  if (!onChange) {
    return (
      <div>onChange is not implemented</div>
    );
  }

  if (hideMinimumScore) {
    return '';
  }

  return (
    <div>
      <FormControlLabel
        control={(
          <Checkbox
            checked={considerInGroundTruth}
            value={considerInGroundTruth}
            color="primary"
            disabled
          />
        )}
        label={<FormattedMessage id="groundtruthview.considerInGroundTruth" />}
      />
      {
        considerInGroundTruth && (
          <div>
            <TextField
              id="maximum-score"
              label={<FormattedMessage id="groundtruthview.maximumScore" />}
              type="number"
              value={currentMaximumScore || 0}
              disabled={disabled || disableMaximumScore}
              variant="standard"
            />
            &nbsp;
            <TextField
              id="minimum-score"
              label={<FormattedMessage id="groundtruthview.minimumScore" />}
              type="number"
              onChange={(event) => onChange('minimumScorePerQuestion', event.target.value, sectionId, questionId)}
              value={currentMinimumScore || 0}
              variant="standard"
              disabled={disabled}
            />
          </div>
        )
      }
    </div>
  );
};

GroundTruthEnableQuestion.defaultProps = {
  currentMinimumScore: undefined,
  currentMaximumScore: undefined,
  hideMinimumScore: false,
  disabled: false,
  disableMaximumScore: false,
};

GroundTruthEnableQuestion.propTypes = {
  onChange: PropTypes.func.isRequired,
  currentMinimumScore: PropTypes.number,
  currentMaximumScore: PropTypes.number,
  hideMinimumScore: PropTypes.bool,
  disabled: PropTypes.bool,
  disableMaximumScore: PropTypes.bool,
  sectionId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  questionId: PropTypes.number.isRequired,
};

export default GroundTruthEnableQuestion;
